<script>
/**
 * AuthorEasterEgg.vue — 复古街机 CRT 风格「隐藏作者页」彩蛋
 *
 * 自包含组件：无 props、无外部依赖，页面数据全部来自后台接口。
 * 复制本文件即可单独使用；请求失败时自动回退到内置默认数据。
 */
const ABOUT_ME_API = "https://api.ckx9.com/nav/about_me";

// 内置默认数据（接口不可用时兜底展示）
const DEFAULT_DATA = {
  topbarTag: "// HIDDEN ROUTE :: AUTHOR",
  heroBadge: "★ STAGE CLEAR ★",
  heroTitle: "恭喜你发现了隐藏作者页",
  heroSub: "YOU FOUND THE DEVELOPER",
  footerCoin: "▶ INSERT COIN TO CONTINUE",
  footerHint: "按 [ESC] 或右上角 ✕ 返回",
  name: "ChaoKai",
  roles: ["全栈开发者 · 彩蛋制造机"],
  bio: "",
  avatar: "",
  stats: [
    { value: "0", label: "提交记录" },
    { value: "0", label: "咖啡杯数" },
    { value: "0", label: "修复 Bug" },
    { value: "∞", label: "摸鱼时长" },
  ],
  socials: [
    { label: "关于我", url: "https://ckx9.com/about_me", type: "link" },
    { label: "邮箱", url: "mailto:you@example.com", type: "email" },
  ],
};

// 自建 GET 请求（不依赖项目 http 工具，复制文件即可独立使用）
function getJson(url) {
  return fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((res) => {
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  });
}

export default {
  name: "AuthorEasterEgg",
  data() {
    return {
      topbarTag: DEFAULT_DATA.topbarTag,
      heroBadge: DEFAULT_DATA.heroBadge,
      heroTitle: DEFAULT_DATA.heroTitle,
      heroSub: DEFAULT_DATA.heroSub,
      footerCoin: DEFAULT_DATA.footerCoin,
      footerHint: DEFAULT_DATA.footerHint,
      name: DEFAULT_DATA.name,
      roles: DEFAULT_DATA.roles.slice(),
      bio: DEFAULT_DATA.bio,
      avatar: DEFAULT_DATA.avatar,
      stats: DEFAULT_DATA.stats.slice(),
      socials: DEFAULT_DATA.socials.slice(),
      typed: "",
      typing: true,
      timer: null,
      // 纯文本弹窗
      textPop: { show: false, label: "", content: "" },
    };
  },
  mounted() {
    this.fetchAuthor();
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    // 从后台拉取作者信息
    fetchAuthor() {
      getJson(ABOUT_ME_API)
        .then((res) => {
          const author = res && res.code === 0 && res.data ? res.data.author : null;
          if (!author) {
            this.startTyping();
            return;
          }
          if (author.topbar_tag) this.topbarTag = author.topbar_tag;
          if (author.hero_badge) this.heroBadge = author.hero_badge;
          if (author.hero_title) this.heroTitle = author.hero_title;
          if (author.hero_sub) this.heroSub = author.hero_sub;
          if (author.footer_coin) this.footerCoin = author.footer_coin;
          if (author.footer_hint) this.footerHint = author.footer_hint;
          if (author.name) this.name = author.name;
          if (Array.isArray(author.roles) && author.roles.length) this.roles = author.roles;
          if (author.bio) this.bio = author.bio;
          if (author.avatar) this.avatar = author.avatar;
          if (Array.isArray(author.stats) && author.stats.length) this.stats = author.stats;
          if (Array.isArray(author.socials) && author.socials.length) {
            this.socials = this.normalizeSocials(author.socials);
          }
          // 数据更新后重新开始打字机效果
          this.startTyping();
        })
        .catch(() => {
          // 请求失败时使用内置默认数据
          this.startTyping();
        });
    },
    // 按后台 type 把 { title, type, value } 转成页面需要的 { label, url, type }
    //   link  -> 外链；email -> mailto 链接；text -> 纯文本（不跳转）
    normalizeSocials(list) {
      return list.map((s) => {
        const value = String(s.value || "").replace(/^`+|`+$/g, "");
        let url = "";
        let type = "text";
        if (s.type === "link") {
          url = value;
          type = "link";
        } else if (s.type === "email") {
          url = "mailto:" + value;
          type = "email";
        } else if (s.type === "text") {
          // 纯文本（如电话），不做链接
          type = "text";
        } else if (/^https?:\/\//i.test(value)) {
          // 类型缺失时兜底：看起来像网址就当链接
          url = value;
          type = "link";
        }
        return { label: s.title || value, url, type, value };
      });
    },
    // 点击纯文本按钮弹出内容
    showText(s) {
      this.textPop = { show: true, label: s.label, content: s.value };
    },
    // 打字机效果
    startTyping() {
      clearInterval(this.timer);
      this.typed = "";
      this.typing = true;
      const full = this.name;
      let i = 0;
      this.timer = setInterval(() => {
        this.typed = full.slice(0, ++i);
        if (i >= full.length) {
          clearInterval(this.timer);
          this.typing = false;
        }
      }, 90);
    },
    handleClose() {
      this.$emit("close");
      // 作为路由页时，直接返回上一页；无历史则回首页
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = "/";
      }
    },
    onKeydown(e) {
      if (e.key === "Escape") {
        // 弹窗打开时优先关闭弹窗，再返回上一页
        if (this.textPop.show) {
          this.textPop.show = false;
        } else {
          this.handleClose();
        }
      }
    },
  },
};
</script>

<template>
  <div class="crt">
    <div class="crt__scan" aria-hidden="true"></div>
    <div class="crt__beam" aria-hidden="true"></div>

    <main class="screen">
      <header class="topbar">
        <span class="topbar__tag">{{ topbarTag }}</span>
        <button class="topbar__close" @click="handleClose" aria-label="返回">✕</button>
      </header>

      <section class="hero">
        <div class="hero__badge">{{ heroBadge }}</div>
        <h1 class="hero__title">{{ heroTitle }}</h1>
        <p class="hero__sub">{{ heroSub }}</p>
      </section>

      <section class="body">
        <div class="avatar">
          <img v-if="avatar" :src="avatar" :alt="name" class="avatar__img" />
          <svg v-else class="avatar__ghost" viewBox="0 0 120 120" role="img" aria-label="像素小幽灵">
            <path d="M24 56 A36 36 0 0 1 96 56 L96 90 L88 78 L80 90 L72 78 L64 90 L56 78 L48 90 L40 78 L32 90 L24 78 Z"
              fill="#f4f6ff" stroke="#0c0c18" stroke-width="4" stroke-linejoin="round" />
            <ellipse cx="44" cy="52" rx="6" ry="9" fill="#14121f" />
            <ellipse cx="76" cy="52" rx="6" ry="9" fill="#14121f" />
            <circle cx="42" cy="48" r="2" fill="#5ef1ff" />
            <circle cx="74" cy="48" r="2" fill="#5ef1ff" />
            <ellipse cx="33" cy="70" rx="5" ry="3.5" fill="#ff5ea8" opacity="0.75" />
            <ellipse cx="87" cy="70" rx="5" ry="3.5" fill="#ff5ea8" opacity="0.75" />
            <path d="M52 62 q8 8 16 0" fill="none" stroke="#14121f" stroke-width="3" stroke-linecap="round" />
          </svg>
        </div>

        <div class="info">
          <h2 class="info__name">{{ typed }}<span class="cursor" :class="{ 'cursor--off': !typing }">▌</span></h2>
          <p class="info__role">{{ roles.join(' · ') }}</p>
          <p class="info__bio" style="white-space: pre-line">{{ bio }}</p>

          <div class="stats">
            <div class="stat" v-for="(s, i) in stats" :key="s.label"
              :style="{ animationDelay: (0.3 + i * 0.08) + 's' }">
              <span class="stat__value">{{ s.value }}</span>
              <span class="stat__label">{{ s.label }}</span>
            </div>
          </div>

          <div class="socials">
            <template v-for="(s, i) in socials">
              <a v-if="s.url" :key="'link-' + s.label" class="btn" :href="s.url" target="_blank" rel="noopener"
                :style="{ animationDelay: (0.5 + i * 0.08) + 's' }">{{ s.label }}</a>
              <button v-else :key="'text-' + s.label" class="btn" :style="{ animationDelay: (0.5 + i * 0.08) + 's' }"
                @click="showText(s)">{{ s.label }}</button>
            </template>
          </div>
        </div>
      </section>

      <footer class="footer">
        <span class="footer__coin blink">{{ footerCoin }}</span>
        <span class="footer__hint">{{ footerHint }}</span>
      </footer>
    </main>

    <!-- 纯文本内容弹窗 -->
    <div v-if="textPop.show" class="crt-pop" @click.self="textPop.show = false">
      <div class="crt-pop__box">
        <div class="crt-pop__title">{{ textPop.label }}</div>
        <div class="crt-pop__content">{{ textPop.content }}</div>
        <button class="btn crt-pop__close" @click="textPop.show = false">关闭</button>
      </div>
    </div>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
</style>

<style scoped>
.crt {
  --bg: #07070f;
  --ink: #eaf6ff;
  --cyan: #5ef1ff;
  --magenta: #ff3d8b;
  --yellow: #ffd23f;
  --green: #57ff9e;

  position: relative;
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 40px 20px;
  overflow: hidden;
  background:
    radial-gradient(120% 90% at 50% 0%, #14182e 0%, #0a0a16 55%, var(--bg) 100%);
  color: var(--ink);
  font-family: 'Press Start 2P', 'Zpix', 'PingFang SC', 'Microsoft YaHei', monospace;
  /* CRT 开机闪烁 */
  animation: crt-flicker 4s infinite;
}

/* 扫描线 */
.crt__scan {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 20;
  background: repeating-linear-gradient(to bottom,
      rgba(0, 0, 0, 0.22) 0px,
      rgba(0, 0, 0, 0.22) 1px,
      transparent 1px,
      transparent 3px);
  mix-blend-mode: multiply;
}

/* 缓慢下移的高亮光带 */
.crt__beam {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 21;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.035), transparent);
  height: 220px;
  animation: beam 7s linear infinite;
}

.screen {
  position: relative;
  z-index: 1;
  width: min(920px, 100%);
  padding: 34px 40px 26px;
  border: 3px solid rgba(94, 241, 255, 0.35);
  border-radius: 22px;
  background: rgba(6, 6, 14, 0.72);
  box-shadow:
    inset 0 0 90px rgba(0, 0, 0, 0.65),
    0 0 0 6px rgba(255, 210, 63, 0.06),
    0 0 48px rgba(94, 241, 255, 0.15);
  /* 屏幕玻璃弧度 */
  transform: perspective(1200px) rotateX(0.6deg);
  animation: screen-on 0.7s cubic-bezier(0.2, 0.9, 0.3, 1) both;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px dashed rgba(94, 241, 255, 0.28);
}

.topbar__tag {
  font-size: 10px;
  letter-spacing: 1px;
  color: var(--green);
  text-shadow: 0 0 8px rgba(87, 255, 158, 0.7);
}

.topbar__close {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid var(--magenta);
  border-radius: 8px;
  background: transparent;
  color: var(--magenta);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.topbar__close:hover {
  background: var(--magenta);
  color: #0c0c18;
  box-shadow: 0 0 16px rgba(255, 61, 139, 0.6);
}

.hero {
  text-align: center;
  padding: 26px 0 30px;
}

.hero__badge {
  display: inline-block;
  padding: 8px 18px;
  margin-bottom: 18px;
  font-size: 13px;
  letter-spacing: 2px;
  color: #1a1204;
  background: var(--yellow);
  border-radius: 4px;
  box-shadow: 0 0 22px rgba(255, 210, 63, 0.5);
  /* animation: pop 0.6s cubic-bezier(0.2, 1.4, 0.4, 1) 0.15s both; */
  animation: glitch 0.3s steps(2) infinite;

}

.hero__title {
  margin: 0;
  font-size: clamp(16px, 3.4vw, 26px);
  line-height: 1.5;
  color: var(--ink);
  text-shadow: 0 0 12px rgba(94, 241, 255, 0.55);
}

.hero__sub {
  margin: 12px 0 0;
  font-size: 10px;
  letter-spacing: 3px;
  color: var(--cyan);
  opacity: 0.85;
}

.body {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 34px;
  align-items: center;
}

.avatar {
  display: grid;
  place-items: center;
}

.avatar__ghost {
  width: 250px;
  height: 240px;
  filter: drop-shadow(0 0 18px rgba(94, 241, 255, 0.35));
  animation: float 3.2s ease-in-out infinite;
}

.avatar__img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 18px;
  border: 3px solid var(--cyan);
  box-shadow: 0 0 22px rgba(94, 241, 255, 0.35);
}

.info__name {
  margin: 0;
  font-size: clamp(15px, 3vw, 22px);
  color: var(--yellow);
  text-shadow: 0 0 14px rgba(255, 210, 63, 0.55);
  transition: text-shadow 0.2s ease;

}

.info__name:hover {
  animation: glitch 0.3s steps(2) infinite;
}

.cursor {
  display: inline-block;
  margin-left: 4px;
  font-size: 0.85em;
  line-height: 1;
  vertical-align: baseline;
  color: var(--cyan);
  animation: blink 0.8s steps(1) infinite;
}

.cursor--off {
  animation: none;
  opacity: 0;
}

.info__role {
  margin: 14px 0 12px;
  font-size: 11px;
  letter-spacing: 1px;
  color: var(--green);
  text-shadow: 0 0 8px rgba(87, 255, 158, 0.6);
}

.info__bio {
  margin: 0 0 22px;
  font-size: 12px;
  line-height: 2.1;
  color: rgba(234, 246, 255, 0.8);
}

.stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 26px;
}

.stat {
  flex: 1 1 100px;
  padding: 14px 10px;
  text-align: center;
  border: 2px solid rgba(94, 241, 255, 0.3);
  border-radius: 10px;
  background: rgba(94, 241, 255, 0.05);
  animation: rise 0.5s ease both;
}

.stat__value {
  display: block;
  min-height: 16px;
  line-height: 1;
  font-size: 16px;
  color: var(--cyan);
  text-shadow: 0 0 10px rgba(94, 241, 255, 0.6);
}

.stat__label {
  display: block;
  margin-top: 8px;
  line-height: 1.4;
  font-size: 9px;
  letter-spacing: 1px;
  color: rgba(234, 246, 255, 0.6);
}

.socials {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.btn {
  padding: 10px 16px;
  font-size: 10px;
  letter-spacing: 1px;
  color: var(--ink);
  text-decoration: none;
  border: 2px solid var(--cyan);
  border-radius: 6px;
  background: transparent;
  transition: transform 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;
  animation: rise 0.5s ease both;
}

.btn:hover {
  transform: translateY(-3px);
  background: var(--cyan);
  color: #0c0c18;
  box-shadow: 0 0 20px rgba(94, 241, 255, 0.55);
}

/* 按钮用于 <button> 元素时去掉浏览器默认样式 */
button.btn {
  font-family: inherit;
  cursor: pointer;
}

/* ---------- 纯文本内容弹窗 ---------- */
.crt-pop {
  position: fixed;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}

.crt-pop__box {
  min-width: 240px;
  max-width: 320px;
  padding: 22px 26px 20px;
  text-align: center;
  border: 3px solid rgba(94, 241, 255, 0.5);
  border-radius: 14px;
  background: #0a0a16;
  box-shadow:
    0 0 34px rgba(94, 241, 255, 0.3),
    inset 0 0 50px rgba(0, 0, 0, 0.55);
  cursor: default;
  animation: pop 0.25s cubic-bezier(0.2, 1.4, 0.4, 1) both;
}

.crt-pop__title {
  margin-bottom: 14px;
  font-size: 11px;
  letter-spacing: 2px;
  color: var(--yellow);
  text-shadow: 0 0 8px rgba(255, 210, 63, 0.55);
}

.crt-pop__content {
  font-size: 13px;
  line-height: 1.8;
  color: var(--cyan);
  text-shadow: 0 0 8px rgba(94, 241, 255, 0.5);
  word-break: break-all;
}

.crt-pop__close {
  margin-top: 18px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
  padding-top: 16px;
  border-top: 1px dashed rgba(94, 241, 255, 0.28);
  font-size: 9px;
  letter-spacing: 1px;
  color: rgba(234, 246, 255, 0.55);
}

.footer__coin {
  color: var(--yellow);
}

.footer__hint {
  text-align: right;
}

/* ---------- 动画 ---------- */
@keyframes crt-flicker {

  0%,
  100% {
    opacity: 1;
  }

  3% {
    opacity: 0.96;
  }

  6% {
    opacity: 1;
  }

  54% {
    opacity: 1;
  }

  55% {
    opacity: 0.94;
  }

  56% {
    opacity: 1;
  }
}

@keyframes beam {
  0% {
    transform: translateY(-220px);
  }

  100% {
    transform: translateY(110vh);
  }
}

@keyframes screen-on {
  0% {
    opacity: 0;
    transform: perspective(1200px) rotateX(0.6deg) scale(0.6);
  }

  40% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
    transform: perspective(1200px) rotateX(0.6deg) scale(1);
  }
}

@keyframes pop {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes rise {
  0% {
    opacity: 0;
    transform: translateY(14px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes blink {

  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}

@keyframes glitch {
  0% {
    text-shadow: 2px 0 var(--magenta), -2px 0 var(--cyan);
  }

  50% {
    text-shadow: -2px 0 var(--magenta), 2px 0 var(--cyan);
  }

  100% {
    text-shadow: 2px 0 var(--magenta), -2px 0 var(--cyan);
  }
}

@media (max-width: 640px) {
  .screen {
    padding: 26px 20px 20px;
  }

  .body {
    grid-template-columns: 1fr;
    gap: 24px;
    text-align: center;
  }

  .stats,
  .socials {
    justify-content: center;
  }

  .footer {
    flex-direction: column;
  }

  .footer__hint {
    text-align: center;
  }
}
</style>
